<template lang="html">

  <section class="filtro-container">
    
    <div class="filtro-wrapper" :style="ownstyles.wrapper_filtro" @keyup.esc="show = false">

      <div class="top-container" :style="ownstyles.wrapper_filtro">

        <div class="container row-between ais">
          <div class="left row-start">
            <!-- OCULTAMOS DE MOMENTO -->
            <!-- <div class="contenedor-input type-text">
              <select name="" id="" v-model="selected.area" @change="emit">
                <option value="">{{$t('orientacion.area_recursos')}}</option>
                <option :value="n" v-for="n in options.localizacion">{{n}}</option>
              </select>
            </div> -->
            <div class="contenedor-input type-text">
              <select name="" id="" v-model="selected.tipo" @change="emit">
                <option value="">{{$t('orientacion.tipo_recursos')}}</option>
                <option :value="tipoRecurso.idTipoCategoriaRecurso" v-for="tipoRecurso in dominios.tipoCategoriaRecursos">{{tipoRecurso.descripcion}}</option>
              </select>
            </div>
            <div class="contenedor-input type-text">
              <input type="text" @keyup="emit" v-model="selected.text" :placeholder="$t('orientacion.buscar_recurso_por_texto')">
            </div>
          </div>

        </div>

      </div>

    </div>

  </section>

</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex';

  import toggle from '@/components/parts/form/toggle'

  export default  {
    name: 'filtro-recursos',
    props : ['length','type','typeInitial'],
    mounted(){
      if(!!this.$route.params.id){
        this.selected.tipo = this.$route.params.id;
        this.requestSetFiltroRecursos(this.selected);
      }
    },
    data() {
      return {
        selected : {
          area : '',
          tipo : '',
          text : ''
        },
        show : false
      }
    },
    methods : {
      ...mapActions(['requestSetFiltroRecursos']),
      emit : function(){
        this.requestSetFiltroRecursos(this.selected);
      },
      erase : function(family, value){
        this.emit();
      },
      erasefiltros : function(){
        this.selected = {
          area : '',
          tipo : '',
          text : ''
        };
        if(!!this.$route.params.id){
          this.selected.tipo = this.$route.params.id;
          this.requestSetFiltroRecursos(this.selected);
        }
        this.emit();
      }
    },
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles',
        dominios : 'getDominios'
      }),
      ownstyles : function(){
        return {
          cover : {
            background : this.colors.light_black
          },
          wrapper_filtro : {
            background : this.colors.light_black
          },
          filter_button : {
            'border-left': `1px solid ${this.colors.medium_black}`
          },
        }
      },
   },
   filters : {
    
  },
  components : {
    'toggle' : toggle,
  },
  watch : {
    'selected' :{
      handler: function () {
        this.emit();
      },
      deep: true
    },
    '$route' : function(){
      this.erasefiltros();
    },
  }

}
</script>

<style scoped lang="scss">

  @import '@/assets/css/colors.scss';
  
  .filtro-el{
    width: 66.666%;
  }

  .filtro-container .filtro-el .contenedor-input{
    width: calc(50% - 20px);
  }

  .radio-container{
    width: auto;
    display: inline-block;
    margin-right: 20px;
    &:last-of-type{
      margin-right:0;
    }
  }

  .filtro-container .resumen p{
    width: 100%;
    margin-bottom: 0;
  }

  @media screen and (max-width: 650px){
    .filtro-el{
      width: 100%;
    }

    .filtro-container .filtro-el .contenedor-input{
      width: 100%;
    }
  }

  @media screen and (max-width: 450px){
    .filtro-container .left .contenedor-input{
      width: 100%;
    }

    .contenedor-input.-radios{
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
    }
  }

  .filtro-container .left {
    width: 100%;
  }
  


  
</style>



// WEBPACK FOOTER //
// src/components/views/orientacion/filtro-recursos.vue